import React, { MouseEventHandler, ReactNode } from 'react'
import { Icon } from '@components/ui/Icon'
import { IconButton } from '@components/ui/Button/IconButton'

interface TrashButtonProps {
  onClick: MouseEventHandler
  marginRight?: boolean
  children?: ReactNode
}

export const TrashButton: React.FC<TrashButtonProps> = (props) => {
  const { onClick, marginRight = false, children, ...rest } = props
  return (
    <IconButton onClick={onClick} {...rest}>
      <Icon name={'trash-icon'} marginRight={marginRight} />
      {children && children}
    </IconButton>
  )
}
